




















import { Vue, Component, Prop } from 'vue-property-decorator'
import LinksStore from '../components/LinksStore.vue'
import scrollTo from '../mixins/scrollTo'

@Component({
  components: {
    LinksStore
  }
})

export default class NavbarApp extends Vue {
  @Prop() burgerIsActive: boolean

  menu = [ { hash: 'about', text: 'О самозанятых' }, { hash: 'plus', text: 'Преимущества' }, { hash: 'instructions', text: 'Стать самозанятым' },
           { hash: null, text: 'Портал поставщиков', link: 'https://partners.wb.ru/' } ]
  links = [
    { img: '/static/images/google-play.png', link: 'https://play.google.com/store/apps/details?id=com.wildberries.portal&hl=ru' },
    { img: '/static/images/app-store.png', link: 'https://apps.apple.com/ru/app/wb-%D0%BF%D0%B0%D1%80%D1%82%D0%BD%D1%91%D1%80%D1%8B/id1466739454' },
  ]

  onBurgerClick() {
    this.$emit('toggleMenu')
  }
  async onMenuItemClick(hash) {
    if (this.$route.hash.slice(1) === hash) {
      this.$router.push({path: '/'}, () => this.$router.push({path: `/#${hash}`}))
    } else this.$router.push({path: `/#${hash}`})
  }
}
